import DataLoader from "dataloader"
import { useSuspenseQuery } from "@tanstack/react-query"
import { get } from "../typed-client/get"
import { PermissionType_AllValues } from "../@client/Theasoft_Data_Permissions"

const loader = new DataLoader(
  async (keys: readonly number[]) => {
    const results = await get("/api/Production/GetProductionPermissions", {
      productionIds: [...keys],
    })
    return keys.map(
      (key) =>
        results.find((x) => x[0] === key)?.[1] || PermissionType_AllValues[0]
    )
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedProductionPermissions(key: number) {
  return useSuspenseQuery({
    queryKey: ["ProductionPermissions", key],
    queryFn: () => loader.load(key),
  })
}
